import { render } from "./OPendingPoint.vue?vue&type=template&id=e708207a&scoped=true"
import script from "./OPendingPoint.vue?vue&type=script&lang=js"
export * from "./OPendingPoint.vue?vue&type=script&lang=js"

import "./OPendingPoint.vue?vue&type=style&index=0&id=e708207a&scoped=true&lang=css"
import "./OPendingPoint.vue?vue&type=style&index=1&id=e708207a&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e708207a"]])

export default __exports__